import React from 'react';

import ArticleTeaser from './Teaser';
import ArticleDetail from './Detail';

const NodeArticle = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <ArticleTeaser {...props} />;
  }

  return <ArticleDetail {...props} />;
};

export default NodeArticle;
